import { checkDateIfSame, getCropUrl, getDefaultTimezone } from "../../../Helpers/utils";
import { ImageModel } from "../../../models/ImageModel";
import { TileModel } from "../../models/TileModel";
import { formatInTimeZone } from 'date-fns-tz';

export default function EventTile({ node, defaultImage }: TileModel) {
  const image = node.properties['image'] as ImageModel ?? null;
  const imageUrl = image ? getCropUrl(image, 'tile') : (defaultImage ?? '');

  const startDate = new Date(node.properties["dateStart"]);
  const endDate = new Date(node.properties["dateEnd"]);
  const sameDate = checkDateIfSame(startDate, endDate); 
  const defaultTimezone = getDefaultTimezone();

  return (
    <div className="cell event-wrapper">
      <div className="thumbnail">
          <a href={node.url}>
              <img src={imageUrl} alt={node.name} />
              <div className="caption">
                  <div className="date">
                      <span>
                          {formatInTimeZone(startDate, defaultTimezone, 'MMM')}
                          <label>{formatInTimeZone(startDate, defaultTimezone, 'dd')}</label>
                      </span>
                  </div>
                  <div className="event-info">
                      <h6>{node.name}</h6>
                      <ul>
                          { !sameDate && 
                          <>
                            <li>
                              <span>Date:</span><span>{formatInTimeZone(startDate, defaultTimezone, 'MMM dd')} - {formatInTimeZone(endDate, defaultTimezone, 'MMM dd')}</span>
                            </li>
                            <li>
                              <span>Time:</span><span>{formatInTimeZone(startDate, defaultTimezone, 'hh:mma')} - {formatInTimeZone(endDate, defaultTimezone, 'hh:mma')}</span>
                            </li>
                          </>
                          } 
                          { sameDate &&
                            <li>
                                <span>Time:</span><span>{formatInTimeZone(startDate, defaultTimezone, 'hh:mma')}</span>
                            </li>
                          }
                          
                          <li><span>Location:</span><span> {node.properties['location']}</span></li>
                      </ul>
                      <span className="go"><i className="fa fa-angle-right"></i></span>
                  </div>
              </div>
          </a>
        </div>
    </div>
  )
}